module.exports = __webpack_public_path__ + "img/close-icon.60d080d4.svg";